import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { questionsQueryKeys } from './questionsQueryKeys';

const getAttachmentList = async (questionId) => {
  return await request.get(
    `/Question/attachments/${questionId}`,
    {},
    'При загрузке вложений для вопроса произошла ошибка',
    []
  );
};

const useQuestionAttachmentList = (questionId, options) =>
  useQuery(
    questionsQueryKeys.attachmentList(questionId),
    () => getAttachmentList(questionId),
    options
  );

export default useQuestionAttachmentList;
